<template>
  <div class="nav-item dropdown">
    <span
      class="dropdown-toggle"
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <font-awesome-icon class="mr-0 ml-2" :icon="['fas', 'ellipsis-h']" />
    </span>

    <div class="dropdown-menu">
      <a @click="$emit('edit')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fal', 'cog']" />
        <span class="k-edit">{{ $t('headline.edit') }}</span>
      </a>

      <a @click="$emit('invite')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fal', 'share-alt']" />
        <span class="k-share">{{ $t('headline.share') }}</span>
      </a>

      <a @click="$emit('sendReminders')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fal', 'clock']" />
        <span class="">{{ $t('headline.sendReminders') }}</span>
      </a>

      <a @click="$emit('export')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fas', 'file-export']" />
        <span class="k-share">{{ $t('headline.export') }}</span>
      </a>

      <a @click="$emit('duplicate')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fas', 'copy']" />
        <span class="k-share">{{ $t('headline.duplicate') }}</span>
      </a>

      <a @click="$emit('remove')" class="dropdown-item" href="#">
        <font-awesome-icon class="mr-1" :icon="['fal', 'trash-alt']" />
        <span class="k-remove">{{ $t('headline.remove') }}</span>
      </a>

      <a
        v-if="poll.closed"
        @click="$emit('close')"
        class="dropdown-item"
        href="#"
      >
        <font-awesome-icon class="mr-1" :icon="['fas', 'lock']" />
        <span class="k-remove">{{ $t('close.open') }}</span>
      </a>

      <a v-else @click="$emit('close')" class="dropdown-item" href="#">

        <font-awesome-icon class="mr-1" :icon="['fas', 'lock-open']" />
        <span class="k-remove">{{ $t('close.close') }}</span>

      </a>
    </div>
  </div>
</template>

<script>

export default {
  props: ['poll']
}
</script>
<style scoped lang="scss">
.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  padding: 0.5rem !important;
}

.dropdown-menu {
  border-radius: 2px;
  padding-top: 8px;
  padding-bottom: 8px;
  box-sizing: border-box;
  width: 200px;
  touch-action: manipulation;
}
</style>
